export const INIT = 'TEXT_RESOURCES_INIT';

/**
 * init text-resources.
 */
export const init = () => {
  return {
    type: INIT
  }
}